import { useState } from 'react';
import RadioButton, { RadioButtonPropTypes } from '../common/RadioButton';
import { useEventBus } from '../../hooks/useEventBus';
import withEventHelper from '../common/EventHelper';

function AuthenticatorMethodRadioButton({ ...props }: RadioButtonPropTypes) {
  const [ displayRadioButton, setDisplayRadioButton ] = useState(true);
  const hideRadioButton = () => {
    setDisplayRadioButton(false);
  };
  useEventBus({ eventName: 'hide-authenticator-method-radio-button', onEvent: hideRadioButton });
  return displayRadioButton ? <RadioButton {...props} /> : <></>;
}

AuthenticatorMethodRadioButton.displayName = 'AuthenticatorMethodRadioButton';
export default withEventHelper(AuthenticatorMethodRadioButton);
